export default __webpack_public_path__ + "static/media/slayt_large.a772bdc0.png";